import { render, staticRenderFns } from "./site-layout.vue?vue&type=template&id=70406412&"
import script from "./site-layout.vue?vue&type=script&lang=js&"
export * from "./site-layout.vue?vue&type=script&lang=js&"
import style0 from "./site-layout.vue?vue&type=style&index=0&id=70406412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports